import { I18nComponente } from "@/types/gerais"

export const Estatisticasi18n: I18nComponente = {
  "pt-BR": {
    estatisticas: "estatísticas",
  },
  "es-CO": {
    estatisticas: "estadísticas",
  }
}
